import { Component, LOCALE_ID, Inject } from '@angular/core';
import { Router } from '@angular/router'
import { TranslationService } from '../../services/translation/translation.service';

@Component({
  selector: 'upsc-language',
  templateUrl: './language.component.html',
  styles: []
})
export class LanguageComponent {

  selectedlanguage: string;

  constructor(public translation: TranslationService) {
    if (sessionStorage.getItem('lang')) {
      this.selectedlanguage = sessionStorage.getItem('lang');
    }
  }

  onchange(lang: string) {
    sessionStorage.setItem('lang', lang);
    // console.log('Selected Language : ' + lang);
    this.translation.changeLanguage(lang);
  }

  /* Below code is for Angular CLI i18n
  languages = [
    { code: 'en', label: 'English' },
    { code: 'de', label: 'German' }
  ];
  public selectedlanguage: string;
  constructor( @Inject(LOCALE_ID) protected localeId: string, private router: Router, private location: LocationStrategy) {
    this.selectedlanguage = localeId;
    //console.log(this.location.getBaseHref());
    console.log(window.location.href);
  }
  onchange(lang: string) {
    window.location.href = window.location.origin + '/' + lang + '/';    
  }
*/

}
